import { FC } from 'react';

import { Award, Certification, Education, Experience, Language, Patent, Publication, Repository } from '../components';

export type SectionName =
	| 'oss_contribution'
	| 'experience'
	| 'education'
	| 'certification'
	| 'language'
	| 'award'
	| 'publication'
	| 'patent';

export const getSection = (section: SectionName) => {
	const map: Record<SectionName, FC<any>> = {
		oss_contribution: Repository,
		experience: Experience,
		education: Education,
		certification: Certification,
		language: Language,
		award: Award,
		patent: Patent,
		publication: Publication
	};
	return map[section];
};
